<!-- <p>my-loader works!</p> -->
<!-- my-loader.component.html -->
<div class="progress-loader" [hidden]="!loading">
    <div class="loading-spinner">
        <!-- <img src="https://loading.io/mod/spinner/gear-set/index.svg"> -->
        <img src="assets/img/loader.svg">
        <span class="loading-message">Please wait...</span>
    </div>
</div>